import axios from "axios";

export const getTrendyolYemekIntegrationSettings = () => {
  return axios.get("/api/v1/trendyol-yemek-integration-settings");
};

export const saveTrendyolYemekIntegrationSettings = (body) => {
  return axios.post("/api/v1/trendyol-yemek-integration-settings", body);
};
